
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {SideBar, SideBarHead, SideList, SideListItemGeneric} from 'app/components/SideBar/';
import QuotaForm from './QuotaForm';
import NewQuotaDef from './models/QuotaDefModel';
import QuotaHome from './components/QuotaHome/QuotaHomeComponent';
import QuotaService from "app/services/quota.service";
import  GetErrorMessage  from 'app/helpers/error-message'
import {ShowError, ShowSuccess} from "app/components/toast"
import { Loading } from '@ecosystem/ui-lib/core/components/Loading';
import {BlockUi} from 'app/components/Basics/';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import Modal from 'app/components/Modal';
import './QuotaComponent.scss';

class Quota extends Component {	
	constructor (props) {
	super(props);
		this.state = {
			search: '',			
			allData: [],
			filteredData: [],			
			loading: false,
			errorMessage: null,
			selectedQuota: null,
			originalSelectedQuota: null,
			uiBlocked: false,
			editorOpen: false,			
			metadata: {
				mediaTypes: []
			}			
		}
	}

	setSearchState(event) {    
		var value = event.target.value;    
		this.setState({search: value});
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.search !== prevState.search) {     
			this.filterQuotas(this.state.search);
		}

		if (this.state.editorOpen !== prevState.editorOpen) {
			if (this.state.editorOpen) {
			//retrigger selected quota if editor was closed        
			this.setState({selectedQuota: this.state.selectedQuota});
			}
		}    
	}

	filterQuotas(term) {		
		if (term !== '') {
			const filteredData = this.state.allData
			.filter(i => (i.name  && i.name.toLowerCase().includes(term.toLowerCase())));
			let newFilteredData = [...filteredData];
			this.setState({ filteredData: newFilteredData});      
		}
		else {
			let newFilteredData = [...this.state.allData];
			this.setState({ filteredData: newFilteredData});     
		}
	}

	componentDidMount() {
		this.queryMetadata();
		this.queryQuotas('');

		this.unblock = this.props.history.block((tx) => {
			if (this.didSelectedQuotaChange()) {
				this.showLoseChangeConfirmationModal(() => {
					this.unblock();
					this.props.history.push(tx.pathname + tx.search);
				});
				return false;
			}
		});
	}

	componentWillUnmount() {
		if (this.unblock) {
			this.unblock();
		}
	}

	queryMetadata() {		
		console.log("queryMetadata")
		QuotaService.getMetadata()
				.then(response => {
					console.log(response.data)
					this.setState({
						metadata: response.data
					});
					return response;
				})
				.catch(error => {			  
					let errorMessage = GetErrorMessage(error);
					console.log("errorMessage on catch");
					console.log(errorMessage);
					this.setState({ loading: false, errorMessage: errorMessage});            
			})
	}

	openEditor() {
		this.setState({ editorOpen: true });
	}

	closeEditorButtonOnClick() {
		if (this.shouldLosePossibleChangesOnEditor(this.closeEditor)) {
			this.closeEditor();
		}
	}

	closeEditor() {
		this.setState({ editorOpen: false });
		this.setSelectedItem(null);
	}

	queryQuotas(term) {
		this.setState({ loading: true, filteredData: [] });
		QuotaService.find(term)
			.then(response =>{				
				this.setState({ filteredData: response.data,
					allData:  response.data,					
					loading: false				
				}, function() { this.filterQuotas(this.state.search); });
				return response;          
			})
			.catch(error => {			  
				let errorMessage = GetErrorMessage(error);
				console.log("errorMessage on catch");
				console.log(errorMessage);
				this.setState({ loading: false, errorMessage: errorMessage});            
			})
	}

	getQuotaById(id) {		
		this.toggleUiBlock(true)
		QuotaService.getQuotaById(id)
			.then(response => {				
				this.updateSelectedQuota(response.data);		
				this.updateSavedQuotaOnList(response.data);					
				this.setState(
					{originalSelectedQuota: cloneDeep(response.data)}
				);
				this.toggleUiBlock(false)
				return response;          
			})
			.catch(error => {			  
				let errorMessage = GetErrorMessage(error);
				console.log("errorMessage on catch");
				console.log(errorMessage);
				this.setState({ errorMessage: errorMessage});    
				this.toggleUiBlock(false)        
			})
	}	

	getSelectedItem(quotaid) {		
		this.setState({clickedQuotaid: quotaid});		
		this.openEditor();
		if (this.shouldLosePossibleChangesOnEditor(()=>this.getQuotaById(quotaid))) {			
			this.getQuotaById(quotaid)			
		}	
	}

	setSelectedItem(selectedQuota) {		
		this.updateSelectedQuota(selectedQuota);
	}	

	shouldLosePossibleChangesOnEditor(callbackAfterLoseChangesConfirmation) {		
		if (this.didSelectedQuotaChange()) {
			this.showLoseChangeConfirmationModal(callbackAfterLoseChangesConfirmation);
			return false;	
		}
		else {	
			return true;
		}	
	}

	didSelectedQuotaChange() {
		let selectedQuota = this.state.selectedQuota;
		if (!selectedQuota) return false;
		let quotasAreEquals = isEqual(selectedQuota, this.state.originalSelectedQuota);
		return !quotasAreEquals;
	  }

	showLoseChangeConfirmationModal(callbackAfterLoseChangesConfirmation) {
		this.setState({ 
			loseChangesModalText: `There are unsaved changes to the survey '${this.state.selectedQuota.name}'. Are you sure do you want to leave without saving?`,
			callbackAfterLoseChangesConfirmation: callbackAfterLoseChangesConfirmation
		});
	}

	confirmLoseChangesModalHandler() {
		let filteredData = this.rollbackToOriginalQuota(this.state.filteredData, this.state.originalSelectedQuota);
		let allData = this.rollbackToOriginalQuota(this.state.allData, this.state.originalSelectedQuota);	

		this.setState({allData: allData, filteredData: filteredData
		}, this.state.callbackAfterLoseChangesConfirmation);
		this.setState({clickedQuotaid: null});
		this.hideLoseChangesModal();
	}

	rollbackToOriginalQuota(list, originalSelectedItem) {
		const index = list.findIndex(item => item.id === this.state.selectedQuota.id);	
		list[index] = originalSelectedItem;
		return list;
	}

	hideLoseChangesModal() {
		this.setState({loseChangesModalText: ''})
	}

	isItemSelected(quotaId) {    
		if (this.state && this.state.selectedQuota && 
			this.state.selectedQuota.id === quotaId) {
			return true;
		} else {
			return false;
		}
	}

	toggleUiBlock(blockUi) {
		this.setState ({uiBlocked: blockUi});
	} 

	addNewQuotaHandler = event => {
		if (this.shouldLosePossibleChangesOnEditor(() => this.addNewQuota())) {
			this.addNewQuota()
		}    
		event.preventDefault();
	}

	addNewQuota() {		
		const newQuota = NewQuotaDef();		
		this.setSelectedItem(null);
		this.setSelectedItem(newQuota);
		this.openEditor();
	}

	removeDeletedQuota(quotaId) {    
		const newFilteredData = this.state.filteredData.filter(i => i.id !== quotaId);
		const newAllData = this.state.allData.filter(i => i.id !== quotaId);
		this.setState({ filteredData: newFilteredData,
			allData: newAllData
			});    
	}

	updateSavedQuotaOnList(selectedQuota) {
		let newFilteredData = [...this.updateQuotaList(this.state.filteredData, selectedQuota)];	
		let newAllData = [...this.updateQuotaList(this.state.allData, selectedQuota)];
		this.setState({filteredData: []});
		this.setState({filteredData: newFilteredData, 
			allData: newAllData
		});
	}

	updateQuotaList(list, selectedQuota) {		
		var index = list.findIndex(q => q.id === selectedQuota.id);
		if (index === -1) {
			list.push(selectedQuota);      
		}
		else {
			list[index] = selectedQuota;      
		}
		return list;
	}

	getListItems() {
		return this.state.filteredData.map(quota => 
			<div key={quota.id}>
				<SideListItemGeneric key={quota.id}
					id={quota.id}					
					getSelectedItem={this.getSelectedItem.bind(this)}				
					isItemSelected={this.isItemSelected(quota.id)}
					menuItemId={quota.id}
				>
					{quota.name}
				</SideListItemGeneric>
		</div>
		)
	}	

	updateSelectedQuota(selectedQuota) {		
		this.setState({selectedQuota: selectedQuota})
	}
	

    render() {
        return (
			<BlockUi tag="div" blocking={this.state.uiBlocked}>  
			<main className="app-body quotas">                   
				<SideBar>
					<SideBarHead canChangeData={this.props.userPermissions?.CanChangeQuota} tagName="SideBarHead" headline="Quota Definitions" titleSize="h3" addButton addButtonLabel="Quota" addButtonCallBack={this.addNewQuotaHandler.bind(this)}
						toolbar={(
						<div>
							{/* <IntroTextIcon className="icon orange clickable" title="Intro Texts"/>
							<SettingsIcon className="icon orange clickable" title="Settings"/> */}
						</div>  
					)} onChange={this.setSearchState.bind(this)}
					/>                  
					<SideList tagName="SideList">                  
						<Loading active={this.state.loading}></Loading>
						<div>
							{this.getListItems()}
						</div>
					</SideList>					
				</SideBar>

				<div className="app-content scrollbox">
					{this.state.editorOpen && ( <QuotaForm openEditor={this.openEditor.bind(this)} 
							didSelectedQuotaChange={this.didSelectedQuotaChange.bind(this)}
							closeEditorButtonOnClick={this.closeEditorButtonOnClick.bind(this)} 
							closeEditor={this.closeEditor.bind(this)}
							removeDeletedQuota={this.removeDeletedQuota.bind(this)} 
							toggleUiBlock={this.toggleUiBlock.bind(this)} 
							selectedQuota={this.state.selectedQuota}
							updateSelectedQuota={this.updateSelectedQuota.bind(this)}
							updateSavedQuotaOnList={this.updateSavedQuotaOnList.bind(this)}							
							getQuotaById={this.getQuotaById.bind(this)}							
							canChangeData={this.props.userPermissions?.CanChangeQuota}
							metadata={this.state.metadata}
							/> )}
					{!this.state.editorOpen && ( <QuotaHome />)}
				</div>
				{this.state.errorMessage && ( <ShowError clearErrorMessage={() => this.setState({errorMessage: ''})} errorMessage={this.state.errorMessage} /> )}
				{this.state.loseChangesModalText && ( <Modal size="small" content={this.state.loseChangesModalText} confirmModalHandler={this.confirmLoseChangesModalHandler.bind(this)} cancelModalHandler={this.hideLoseChangesModal.bind(this)} />)}
			</main>
			</BlockUi>
        );
    }
}

export default withRouter(Quota);